"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));

var _Button = _interopRequireDefault(require("../Button"));

var AccountSuccess = function AccountSuccess(_ref) {
  var isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      email = _ref.email,
      onContinue = _ref.onContinue,
      onImport = _ref.onImport;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    onClose: toggle,
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden lg:flex items-center justify-center bg-primary p-12"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('onboard-logo'),
    alt: "OnMail",
    style: {
      width: 350
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-8 py-20"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-3"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-3 text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    fontSize: "large"
  })), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-5xl font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "retrofit.success.header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  })))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-8 text-medium"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "retrofit.success.description",
    values: {
      email: email
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-dark font-bold"
  }))), /*#__PURE__*/_react["default"].createElement(ProTip, {
    icon: /*#__PURE__*/_react["default"].createElement("span", {
      className: "rounded-full bg-light text-white p-1 block"
    }, /*#__PURE__*/_react["default"].createElement(_FilterList["default"], null)),
    header: t('tooltip.protip.title'),
    description: /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "retrofit.success.protip.description",
      values: {
        email: email
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }))
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-20 text-primary cursor-pointer font-bold",
    onClick: onImport
  }, t('retrofit.success.importAnother')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-20"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-1/2",
    onClick: onContinue
  }, t('button.continue'))))));
};

var ProTip = function ProTip(_ref2) {
  var header = _ref2.header,
      description = _ref2.description,
      icon = _ref2.icon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded shadow-lg p-5 flex items-center w-2/3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-5"
  }, icon), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "font-bold text-sm"
  }, header), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs text-light"
  }, description)));
};

var _default = AccountSuccess;
exports["default"] = _default;
//# sourceMappingURL=AccountSuccess.js.map